import React, { Fragment, useState, useEffect } from 'react';
import Button from "../../../Button";
import { Controller, useForm } from 'react-hook-form';
import makeAnimated from 'react-select/animated';
import Select from 'react-select'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import School from "../../../../models/School";
import Student from "../../../../models/Student";
import AsyncSelect from 'react-select/async'
const animatedComponents = makeAnimated();
import styles from '../WorkOrder/WorkOrder.module.sass';

const Form = ({ studentImageId }) => {
  const { register, handleSubmit, control, trigger, watch, setValue, unregister, formState: { errors } } = useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [school, setSchool] = useState();
  const [students, setStudents] = useState();
  const studentId = watch('student_id');

  useEffect(() => {
    if (!studentId) return;

    Student
      .where({ school_id: school, is_enrolled: true, student_id: studentId })
      .all()
      .then((response) => {
        setStudents(response.data[0])
      })
      .catch((e) => {
        toast('There was no student found with that ID. Please double check the ID and enter again', { type: 'error' })
      });
  }, [studentId])

  const loadSchoolOptionsQuery = ({ valueField }) => (value, callback) => {
    School
      .where({
        sales_stat: { match: 'CUST' },
        name: { match: value },
      })
      .order({ name: 'asc' })
      .all()
      .then((res) => {
        const options = res.data.map((e) => ({ label: e.name, value: e.id, data: e }))
        callback(options)
      })
  }

  const loadSchoolOptions = loadSchoolOptionsQuery('name')

  const onSubmit = (data) => {
    setIsSubmitting(true)
    axios
      .post(`/admin/student_images/${studentImageId}/transfer`, { student_id: students.id })
      .then(() => {
        window.location = `/admin/student_images?student_id=${students.id}`
      })
      .catch(() => {
        setIsSubmitting(false)
        toast.error("Something went wrong creating the work order. Please refresh and try again.", {
          position: "bottom-left",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  }

  return (
    <Fragment>
      <form className={styles.largeForm} onSubmit={handleSubmit(onSubmit)}>
        <label className={styles.label}>School</label>
        <AsyncSelect
          cacheOptions
          defaultOptions
          placeholder="Select the school for the student"
          name={name}
          loadOptions={loadSchoolOptions}
          onChange={(opt) => setSchool(opt.value)}
        />

        {school && (
          <>
            <label className={styles.label}>Student ID</label>
            <input
              className={`${styles.input} ${styles.textInput}`}
              {...register("student_id", { required: true })}
            />
            {!students && <div>No student found with ID {studentId}</div>}

            {students && <div>Transferring image to {students.fullName && students.fullName()}</div>}

          </>
        )}

        <Button
          classes={styles.submit}
          fullWidth
          variant='submit'
          disabled={isSubmitting || !students}
        >
          Submit
        </Button>
      </form>
    </Fragment>
  )
}

export default Form;
